import getPartnerData from './partner-data';

const getIsB2C = (rootState) => {
  const { isWhiteLabel } = getPartnerData(rootState);
  return !isWhiteLabel;
};

export default getIsB2C;
